import {observer} from 'mobx-react';
import {Input, Select2} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {t} from 'shared/core';
import PAY_RATE_UNIT_TYPES from 'main/stores/employees/payRateUnitTypes';

const PayRate = observer(({viewModel}) => {
  const {uiState} = viewModel;

  if (uiState.massUpdate.readOnly && !viewModel.fields.get('payRate').has('newValue')) {
    return (
      <div className='waterloo'>
        <FormattedMessage id='mass_updates.edit.Not Changed'/>
      </div>
    );
  }

  const rawValue = viewModel.get('payRate', evaluator).get('value');
  const isHash = rawValue !== null && typeof rawValue === 'object';
  const value = isHash ? rawValue.value : rawValue;
  const unit = isHash ? rawValue.unit : viewModel.get('payRate', evaluator).get('payRateUnit');

  return (
    <div>
      <Input
        value={value}
        onChange={e => viewModel.set('payRate', {value: e.target.value, unit})}
        disabled={viewModel.disabled}
        connectedRight={
          <Select2
            value={unit}
            onChange={e => viewModel.set('payRate', {value, unit: e.target.value})}
            disabled={viewModel.disabled}
          >
            {PAY_RATE_UNIT_TYPES.map(unitType =>
              <option value={unitType.id} key={unitType.id}>{t(unitType.name)}</option>
            )}
          </Select2>
        }
      />
      <div className='jumbo mt1'>
        <FormattedMessage
          id={viewModel.disabled ? 'mass_updates.edit.PREVIOUS_PAY_RATE' : 'mass_updates.edit.CURRENT_PAY_RATE'}
          values={{
            payRate: viewModel.get('payRate', evaluator).get('oldValue'),
            currency: viewModel.get('payRate', evaluator).get('payRateCurrency'),
            unit: viewModel.get('payRate', evaluator).get('payRateUnit')
          }}
        />
      </div>
    </div>
  );
});

function evaluator(bulkValue, oldValue) {
  const newValue = parseFloat(oldValue) * (1 + bulkValue / 100.0);

  return newValue.toFixed(2);
}

export default PayRate;
